/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown>, reason: NonNullable<unknown> }} Error_Certification_Badge_FieldInputs */

const vi_error_certification_badge_field = /** @type {(inputs: Error_Certification_Badge_FieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logo chứng nhận chưa hợp lệ ở ô ${i?.field} (${i?.reason}).`)
};

/**

* @param {Error_Certification_Badge_FieldInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_certification_badge_field = /** @type {((inputs: Error_Certification_Badge_FieldInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Certification_Badge_FieldInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_certification_badge_field(inputs)
});